<app-header [headerTitle]="'GROUP.PICKER.TITLE' | translate">
  <div leftContent class="fu-header-icon-wrapper" (click)="closeModal()">
    <ion-icon name="x-close"></ion-icon>
  </div>
</app-header>

<ion-content class="fu-theme fu-theme--light-challenge">
  @let overview = groupOverview();
  @if (overview && overview.joinedClubs.length > 0) {
    <div class="fu-content fu-gap fu-gap--m">
      @for (group of overview.joinedClubs; track group.id) {
        <div class="fu-cursor-pointer" (click)="selectClub(group)" data-qa-id="group-item">
          <app-club-card [club]="group" [showDetails]="false" class="fu-pointer-events-none"></app-club-card>
        </div>
      }
    </div>
  } @else {
    <div class="fu-content fu-align-center fu-justify-center fu-gap fu-gap--l fu-text-center">
      <p class="fu-sub-heading fu-subtitle--mild-grey">{{ 'GROUP.PICKER.NO_GROUPS' | translate }}</p>
      <ion-button class="fu-button" (click)="navigateToClubs()" data-qa-id="join-group-button">
        {{ 'GROUP.PICKER.JOIN_GROUP' | translate }}
      </ion-button>
    </div>
  }
</ion-content>
